import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MicroscopeResolver } from './resolver/microscope.resolver';
import { MicroscopeEditScreenComponent } from './screens/edit/microscope-edit-screen.component';

const routes: Routes = [
  {
    path: '',
    data: { breadcrumb: 'Microscopes' },
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./screens/microscope-table-screen.component').then(
            (m) => m.MicroscopeTableScreen,
          ),
      },
      {
        path: 'create',
        pathMatch: 'full',
        data: { breadcrumb: 'Create' },
        component: MicroscopeEditScreenComponent,
      },
      {
        path: ':id',
        data: { breadcrumbDynamic: 'microscope' },
        resolve: { data: MicroscopeResolver },
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: MicroscopeEditScreenComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MicroscopeRoutingModule {}
